//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['value'],
  data() {
    return {
      display: true,
      content: ''
    }
  },
  methods: {
    parse(v) {
      const n = parseFloat(String(v).replace(',', '.'))
      return isNaN(n) ? null : n
    },
    handleInput(e) {
      // dot -> comma, strip everything except digits and comma
      let v = e.target.value.replace(/\./g, ',').replace(/[^\d,]/g, '')
      // keep only the first comma, max 2 decimals
      const i = v.indexOf(',')
      if (i !== -1) {
        v = v.slice(0, i + 1) + v.slice(i + 1).replace(/,/g, '').slice(0, 2)
      }
      this.content = v
      e.target.value = v
      this.$emit('input', this.parse(v))
    },
    hideInput() {
      this.display = true
      this.$emit('input', this.parse(this.content))

      if (this.operatingSystem === 'android') {
        setTimeout(() => {
          window.scrollTo(0, 0)
          document.body.scrollTop = 0
        }, 1000)
      }
    },
    showInput() {
      this.display = false
      this.content = ''
      this.$nextTick(() => {
        this.$refs.money.focus()
      })
    }
  }
}
